function PageCard({ page }) {
  return (
    <div className="page relative mb-5 flex flex-col overflow-hidden border-b border-solid border-neutral-900 pb-5 last:border-0 lg:mb-6 lg:pb-6 last:mb-0 last:pb-0">
      <h3 className="mb-2 text-xs font-extrabold uppercase text-neutral-900">{page.title}</h3>
      {page.content ? (
        <div className="mb-3 max-w-[1000px] text-xs text-neutral-700">{page.content}</div>
      ) : null}
      <a href={page.url} className="animation-link text-xs font-normal text-neutral-700">
        {translate.article.readMore}
      </a>
    </div>
  )
}

export default PageCard
